export const environment = {
  // Served by the API itself, so a relative base works on any host (ACA FQDN, localhost).
  apiUrl: '',
  mediaBaseUrl: 'https://pandora-stg.media.qmutator.com',

  production: false,
  msalConfig: {
    auth: {
      clientId: '65bc6984-aa79-4fed-ab3f-92c7e30ced7f',
      authority:
        'https://login.microsoftonline.com/2d087612-4ff3-485c-9d13-64dc29ff1f23/oauth2/v2.0',
    },
  },
};
